import { f as o } from "./creditFigmaToken-9b4c3a39.js";
const d = {
  tabletMin: 600,
  laptopMin: 1024,
  desktopMin: 1440,
  wideScreenMin: 1640,
  ultraWideScreenMin: 1920
}, p = {
  /* Exact Screens */
  mobile: `(width < ${d.tabletMin}px)`,
  // below 600px
  tablet: `(${d.tabletMin}px <= width < ${d.laptopMin}px)`,
  // from between 600 and 1023px
  desktop: `${d.desktopMin}px <= width < ${d.wideScreenMin}px)`,
  //from between 1440px and 1639px
  tabletAndDown: `(width < ${d.laptopMin}px)`,
  // below 1024px
  /* Above Screens */
  tabletAndUp: `(width >= ${d.tabletMin}px)`,
  // above 600px
  laptopAndUp: `(width >= ${d.laptopMin}px)`,
  // above 1024px
  desktopAndUp: `(width >= ${d.desktopMin}px)`,
  // above 1440px
  wideScreenAndUp: `(width >= ${d.wideScreenMin}px)`,
  // above 1640px
  ultraWideScreenAndUp: `(width >= ${d.ultraWideScreenMin}px)`
  // above 1920px
}, e = {
  fpds: {
    color: {
      fordBlue: {
        100: "#e6e6ef",
        // This is the Ford Blue brand color with 90% white added.
        200: "#cccede",
        // This is the Ford Blue brand color with 80% white added.
        300: "#b3b5ce",
        // This is the Ford Blue brand color with 70% white added.
        400: "#999dbd",
        // This is the Ford Blue brand color with 60% white added.
        500: "#8084ad",
        // This is the Ford Blue brand color with 50% white added.
        600: "#666b9d",
        // This is the Ford Blue brand color with 40% white added.
        700: "#4d538c",
        // This is the Ford Blue brand color with 30% white added.
        800: "#333a7c",
        // This is the Ford Blue brand color with 20% white added.
        900: "#1a226b",
        // This is the Ford Blue brand color with 10% white added.
        1e3: "#00095b",
        // This is the Ford Blue brand color.
        1100: "#000852",
        // This is the Ford Blue brand color with 10% black added.
        1200: "#000749",
        // This is the Ford Blue brand color with 20% black added.
        1300: "#000640",
        // This is the Ford Blue brand color with 30% black added.
        1400: "#00052E"
        // This is the Ford Blue brand color with 50% black added.
      },
      grabber: {
        100: "#e8e6fe",
        // This is the Ford Grabber brand color with 90% white added.
        200: "#d1ccfd",
        // This is the Ford Grabber brand color with 80% white added.
        300: "#b9b3fc",
        // This is the Ford Grabber brand color with 70% white added.
        400: "#a299fb",
        // This is the Ford Grabber brand color with 60% white added.
        500: "#8b80fa",
        // This is the Ford Grabber brand color with 50% white added.
        600: "#7466f8",
        // This is the Ford Grabber brand color with 40% white added.
        700: "#5d4df7",
        // This is the Ford Grabber brand color with 30% white added.
        800: "#4533f6",
        // This is the Ford Grabber brand color with 20% white added.
        900: "#2e19f5",
        // This is the Ford Grabber brand color with 10% white added.
        1e3: "#1700f4",
        // This is the Ford Grabber brand color.
        1100: "#1500dc",
        // This is the Ford Grabber brand color with 10% black added.
        1200: "#1200c3",
        // This is the Ford Grabber brand color with 20% black added.
        1300: "#1000AB",
        // This is the Ford Grabber brand color with 30% black added.
        1400: "#0C007A"
        // This is the Ford Grabber brand color with 50% black added.
      },
      skyview: {
        100: "#e6f1fd",
        // This is the Ford Skyview brand color with 90% white added.
        200: "#cde2fc",
        // This is the Ford Skyview brand color with 80% white added.
        300: "#b4d4fa",
        // This is the Ford Skyview brand color with 70% white added.
        400: "#9bc5f9",
        // This is the Ford Skyview brand color with 60% white added.
        500: "#83b7f7",
        // This is the Ford Skyview brand color with 50% white added.
        600: "#6aa9f5",
        // This is the Ford Skyview brand color with 40% white added.
        700: "#519af4",
        // This is the Ford Skyview brand color with 30% white added.
        800: "#388cf2",
        // This is the Ford Skyview brand color with 20% white added.
        900: "#1f7df1",
        // This is the Ford Skyview brand color with 10% white added.
        1e3: "#066fef",
        // This is the Ford Skyview brand color.
        1100: "#0564d7",
        // This is the Ford Skyview brand color with 10% black added.
        1200: "#0559bf",
        // This is the Ford Skyview brand color with 20% black added.
        1300: "#294D7A",
        // This is the skyview 700 color with 50% black added.
        1400: "#203E62"
        // This is the skyview 700 color with 60% black added.
      },
      neutral: {
        100: "#fafafb",
        // This is the Twilight brand color with 90% white added.
        200: "#f5f6f7",
        // This is the Twilight brand color with 80% white added.
        300: "#e6e8ea",
        // This is the Twilight brand color with 70% white added.
        400: "#d1d5d9",
        // This is the Twilight brand color with 60% white added.
        500: "#9ca3ad",
        // This is the Twilight brand color with 50% white added.
        600: "#6b7786",
        // This is the Twilight brand color with 40% white added.
        700: "#4d5b6d",
        // This is the Twilight brand color with 30% white added.
        800: "#38485c",
        // This is the Twilight brand color with 20% white added.
        900: "#1f3047",
        // This is the Twilight brand color with 10% white added.
        1e3: "#00142e",
        // This is the Twilight brand color.
        1100: "#001229",
        // This is the Twilight brand color with 10% black added.
        1200: "#001025",
        // This is the Ford Twilight brand color with 20% black added.
        1300: "#000e20",
        // This is the Ford Twilight brand color with 30% black added.
        1400: "#000000",
        // 100% Black.
        "000": "#ffffff"
        // White 100%
      },
      green: {
        100: "#e6f3e6",
        // This is the green color with 90% white added.
        200: "#cce6cc",
        // This is the green color with 80% white added.
        300: "#b3dab3",
        // This is the green color with 70% white added.
        400: "#99cd99",
        // This is the green color with 60% white added.
        500: "#80c180",
        // This is the green color with 50% white added.
        600: "#66b466",
        // This is the green color with 40% white added.
        700: "#4da84d",
        // This is the green color with 30% white added.
        800: "#339b33",
        // This is the green color with 20% white added.
        900: "#198f19",
        // This is the green color with 10% white added.
        1e3: "#008200",
        // This is the green color.
        1100: "#007500",
        // This is the green color with 10% black added.
        1200: "#006800",
        // This is the green color with 20% black added.
        1300: "#275427",
        // This is green 700 color with 50% black added.
        1400: "#1F431F"
        // This is green 700 color with 60% black added.
      },
      amber: {
        100: "#FCF2E6",
        // This is the amber color with 90% white added.
        200: "#F8E4CC",
        // This is the amber color with 80% white added.
        300: "#F5D7B3",
        // This is the amber color with 70% white added.
        400: "#F1CA99",
        // This is the amber color with 60% white added.
        500: "#EEBC80",
        // This is the amber color with 50% white added.
        600: "#E7A24D",
        // This is the amber color with 40% white added.
        700: "#E0871A",
        // This is the amber color with 30% white added.
        800: "#DD7A01",
        // This is the amber color with 20% white added.
        900: "#C76E01",
        // This is the amber color with 10% white added.
        1e3: "#B16201",
        // This is the amber color.
        1100: "#9B5501",
        // This is the amber color with 10% black added.
        1200: "#854901",
        // This is the amber color with 20% black added.
        1300: "#684227",
        // This is the amber 700 color with 50% black added.
        1400: "#53341F"
        // This is the amber 700 color with 60% black added.
      },
      red: {
        100: "#fbeae7",
        // This is the red color with 90% white added.
        200: "#f7d5ce",
        // This is the red color with 80% white added.
        300: "#f3c0b6",
        // This is the red color with 70% white added.
        400: "#efab9d",
        // This is the red color with 60% white added.
        500: "#eb9685",
        // This is the red color with 50% white added.
        600: "#e6816c",
        // This is the red color with 40% white added.
        700: "#e26c54",
        // This is the red color with 30% white added.
        800: "#de573b",
        // This is the red color with 20% white added.
        900: "#da4223",
        // This is the red color with 10% white added.
        1e3: "#d62d0a",
        // This is the red color.
        1100: "#c12909",
        // This is the red color with 10% black added.
        1200: "#ab2408",
        // This is the red color with 20% black added.
        1300: "#71362A",
        // This is the red 700 color with 50% black added.
        1400: "#5A2B22"
        // This is the red 700 color with 60% black added.
      },
      opacity: {
        light: {
          "00": "#00142e00",
          // This is the neutral.1000 at 0% opacity.
          10: "#00142e14",
          // This is the neutral.1000 at 10% opacity.
          20: "#00142e33",
          // This is the neutral.1000 at 20% opacity.
          30: "#00142e4d",
          // This is the neutral.1000 at 30% opacity.
          40: "#00142e66",
          // This is the neutral.1000 at 40% opacity.
          50: "#00142e80",
          // This is the neutral.1000 at 50% opacity.
          60: "#00142e99",
          // This is the neutral.1000 at 60% opacity.
          70: "#00142eb3",
          // This is the neutral.1000 at 70% opacity.
          80: "#00142ecc",
          // This is the neutral.1000 at 80% opacity.
          90: "#00142ee6",
          // This is the neutral.1000 at 90% opacity.
          100: "#00142e"
          // This is the neutral.1000 color.
        },
        dark: {
          "00": "#ffffff00",
          // This is the neutral.000 at 0% opacity.
          10: "#ffffff1a",
          // This is the neutral.000 at 10% opacity.
          20: "#ffffff33",
          // This is the neutral.000 at 20% opacity.
          30: "#ffffff4d",
          // This is the neutral.000 at 30% opacity.
          40: "#ffffff66",
          // This is the neutral.000 at 40% opacity.
          50: "#ffffff80",
          // This is the neutral.000 at 50% opacity.
          60: "#ffffff99",
          // This is the neutral.000 at 60% opacity.
          70: "#ffffffb3",
          // This is the neutral.000 at 70% opacity.
          80: "#ffffffcc",
          // This is the neutral.000 at 80% opacity.
          90: "#ffffffe6",
          // This is the neutral.000 at 90% opacity.
          100: "#ffffff"
          // This is the neutral.000 color.
        },
        skyview: {
          200: "#4DCDE2FC",
          500: "#4D83B7F7",
          800: "#4D388CF2",
          1100: "#4D0564D7",
          1400: "#4D203E62"
        },
        fordBlue: {
          200: "#4DCCCEDE",
          500: "#4D8084AD",
          800: "#4D333A7C",
          1100: "#4D000852",
          1400: "#4D00052E"
        },
        fordGrabber: {
          200: "#4DD1CCFD",
          500: "#4D8B80FA",
          800: "#4D4533F6",
          1100: "#4D1700F4",
          1400: "#4D251F63"
        },
        neutral: {
          200: "#4DF5F6F7",
          500: "#4D9CA3AD",
          800: "#4D38485c",
          1100: "#4D00142E",
          1400: "#4D000000"
        },
        red: {
          200: "#4DF7D5CE",
          500: "#4DEB9685",
          800: "#4DDE573B",
          1100: "#4DC12909",
          1400: "#4D5A2B22"
        },
        orange: {
          200: "#4DFFD3AA",
          500: "#4DFFA755",
          800: "#4DE67205",
          1100: "#4DA33B03",
          1400: "#4D612004"
        },
        green: {
          200: "#4DCCE6CC",
          500: "#4D80C180",
          800: "#4D339B33",
          1100: "#4D007500",
          1400: "#4D1F431F"
        },
        teal: {
          200: "#4DB0FFFF",
          500: "#4D25DBDB",
          800: "#4D00A5A5",
          1100: "#4D0C7483",
          1400: "#4D003F54"
        },
        magenta: {
          200: "#4DFFBCE9",
          500: "#4DF678CC",
          800: "#4DF644BB",
          1100: "#4DB11C7E",
          1400: "#4D4B0735"
        },
        purple: {
          200: "#4DEFDEFC",
          500: "#4DD3AAF4",
          800: "#4DBB6FF9",
          1100: "#4D8746C6",
          1400: "#4D50098E"
        },
        yellow: {
          200: "#4DFFF2CC",
          500: "#4DFFDF80",
          800: "#4DFFCD33",
          1100: "#4DFFC000",
          1400: "#4D66541F"
        }
      },
      yellow: {
        100: "#FFF9E5",
        // This is the yellow color with 90% white added.
        200: "#FFF2CC",
        // This is the yellow color with 80% white added.
        300: "#FFECB2",
        // This is the yellow color with 70% white added.
        400: "#FFE699",
        // This is the yellow color with 60% white added.
        500: "#FFDF80",
        // This is the yellow color with 50% white added.
        600: "#FFD966",
        // This is the yellow color with 40% white added.
        700: "#FFD34D",
        // This is the yellow color with 30% white added.
        800: "#FFCD33",
        // This is the yellow color with 20% white added.
        900: "#FFC61A",
        // This is the yellow color with 10% white added.
        1e3: "#FFC000",
        // This is the yellow color.
        1100: "#E5AD00",
        // This is the yellow color with 10% black added.
        1200: "#CC9A00",
        // This is the yellow color with 20% black added.
        1300: "#B28600",
        // This is the yellow color with 30% black added.
        1400: "#664D00"
        // This is the yellow color with 50% black added.
      },
      twilight: {
        100: "#fafafb",
        // This is the Twilight brand color with 90% white added.
        200: "#f5f6f7",
        // This is the Twilight brand color with 80% white added.
        300: "#e6e8ea",
        // This is the Twilight brand color with 70% white added.
        400: "#d1d5d9",
        // This is the Twilight brand color with 60% white added.
        500: "#9ca3ad",
        // This is the Twilight brand color with 50% white added.
        600: "#6b7786",
        // This is the Twilight brand color with 40% white added.
        700: "#4d5b6d",
        // This is the Twilight brand color with 30% white added.
        800: "#38485c",
        // This is the Twilight brand color with 20% white added.
        900: "#1f3047",
        // This is the Twilight brand color with 10% white added.
        1e3: "#00142e",
        // This is the Twilight brand color.
        1100: "#001229",
        // This is the Twilight brand color with 10% black added.
        1200: "#001025",
        // This is the Ford Twilight brand color with 20% black added.
        1300: "#000e20",
        // This is the Ford Twilight brand color with 30% black added.
        1400: "#000000",
        // 100% Black
        "000": "#ffffff"
        // White 100%
      },
      teal: {
        200: "#B0FFFF",
        500: "#25DBDB",
        800: "#00A5A5",
        1100: "#0C7483",
        1400: "#003F54"
      },
      orange: {
        200: "#FFD3AA",
        500: "#FFA755",
        800: "#E67205",
        1100: "#A33B03",
        1400: "#612004"
      },
      magenta: {
        200: "#FFBCE9",
        500: "#F678CC",
        800: "#F644BB",
        1100: "#B11C7E",
        1400: "#4B0735"
      },
      purple: {
        200: "#EFDEFC",
        500: "#D3AAF4",
        800: "#BB6FF9",
        1100: "#8746C6",
        1400: "#50098E"
      },
      surface: {
        100: "#18222E",
        200: "#1D2632",
        300: "#1F2935",
        400: "#222B37",
        500: "#27303B",
        600: "#29323D",
        700: "#2E3742",
        800: "#303944",
        900: "#464E58",
        "000": "#0C1623"
      }
    },
    type: {
      lineHeights: {
        400: "16px",
        500: "20px",
        600: "24px",
        700: "28px",
        800: "32px",
        1e3: "40px",
        1200: "48px"
      },
      fontFamilies: {
        inter: "Inter",
        FordF1: "Ford F-1"
      },
      fontWeights: {
        fordF1: {
          regular: "400",
          medium: "500",
          semiBold: "600"
        },
        inter: {
          regular: "400",
          medium: "500",
          semiBold: "600"
        },
        fpm: {
          regular: "Regular",
          // Use for regular weight text.
          medium: "Medium",
          // Use for Medium weight text.
          semiBold: "Semibold"
          // Use for semi-Bold weight Text.
        }
      },
      fontSize: {
        250: "10px",
        300: "12px",
        350: "14px",
        400: "16px",
        450: "18px",
        500: "20px",
        550: "22px",
        600: "24px",
        700: "28px",
        800: "32px",
        1e3: "40px"
      }
    },
    number: {
      "000": "0px",
      // 0px number
      "025": "1px",
      // 1px number
      "050": "2px",
      // 2px number
      100: "4px",
      // 4px number
      200: "8px",
      // 8px number
      300: "12px",
      // 12px number
      400: "16px",
      // 16px number
      500: "20px",
      // 20px number
      600: "24px",
      // 24px number
      700: "28px",
      // 28px number
      800: "32px",
      // 32px number
      1e3: "40px",
      // 40px number
      1100: "44px",
      // 44px number
      1200: "48px",
      // 48px number
      1500: "60px",
      // 60px number
      1600: "64px",
      // 64px number
      1800: "72px",
      // 72px number
      2e3: "80px",
      // 80px number
      2200: "88px",
      // 88px number
      2400: "96px",
      // 96px number
      2600: "104px",
      // 104px number
      5100: "204px",
      // 204px number
      max: "8000px"
      // 204px number
    }
  },
  fpm: {
    color: {
      neutral: {
        100: "#F0F0F0",
        // This is the neutral brand color.
        200: "#D8D8D8",
        // This is the neutral brand color with 10% black added.
        300: "#C0C0C0",
        // This is the neutral brand color with 20% black added.
        400: "#A8A8A8",
        // This is the neutral brand color with 30% black added.
        500: "#909090",
        // This is the neutral brand color with 40% black added.
        600: "#787878",
        // This is the neutral brand color with 50% black added.
        700: "#606060",
        // This is the neutral brand color with 60% black added.
        800: "#484848",
        // This is the neutral brand color with 70% black added.
        900: "#303030",
        // This is the neutral brand color with 80% black added.
        1e3: "#181818",
        // This is the neutral brand color with 90% black added.
        1100: "#000000",
        // Black 100%
        "000": "#FFFFFF"
        // White 100%
      },
      surface: {
        100: "#F0F0F0",
        // This is the neutral brand color.
        200: "#121212",
        // Dark mode base surface color
        300: "#1e1e1e",
        // Dark mode surface color at 01dp
        400: "#232323",
        // Dark mode surface color at 02dp
        500: "#252525",
        // Dark mode surface color at 03dp
        600: "#272727",
        // Dark mode surface color at 04dp
        700: "#2c2c2c",
        // Dark mode surface color at 06dp
        800: "#2e2e2e",
        // Dark mode surface color at 08dp
        900: "#333333",
        // Dark mode surface color at 12dp
        1e3: "#363636",
        // Dark mode surface color at 16dp
        1100: "#383838",
        // Dark mode surface color at 24dp
        "000": "#FFFFFF"
        // White 100%
      },
      opacity: {
        light: {
          100: "#18181866"
          // scrim color for light mode
        },
        dark: {
          100: "#18181899"
          // scrim color for lightmode
        }
      }
    }
  },
  $themes: [],
  $metadata: {
    tokenSetOrder: ["primitive", "fpds", "fpm"]
  }
}, a = {
  "fpds-light": {
    type: {
      headline: {
        XXL: {
          value: {
            fontFamily: e.fpds.type.fontFamilies.FordF1,
            fontWeight: e.fpds.type.fontWeights.fordF1.semiBold,
            // Weight Semi-bold
            lineHeight: e.fpds.type.lineHeights[1200],
            // Height 48px
            fontSize: e.fpds.type.fontSize[1e3]
            // Font-size 40px
          },
          type: "typography"
        },
        XL: {
          value: {
            fontFamily: e.fpds.type.fontFamilies.FordF1,
            fontWeight: e.fpds.type.fontWeights.fordF1.semiBold,
            // Weight Semi-bold
            lineHeight: e.fpds.type.lineHeights[1e3],
            // Height 40px
            fontSize: e.fpds.type.fontSize[800]
            // Font-size 32px
          },
          type: "typography"
        },
        L: {
          value: {
            fontFamily: e.fpds.type.fontFamilies.FordF1,
            fontWeight: e.fpds.type.fontWeights.fordF1.semiBold,
            // Weight Semi-bold
            lineHeight: e.fpds.type.lineHeights[800],
            // Height 32px
            fontSize: e.fpds.type.fontSize[600]
            // Font-size 24px
          },
          type: "typography"
        },
        M: {
          value: {
            fontFamily: e.fpds.type.fontFamilies.FordF1,
            fontWeight: e.fpds.type.fontWeights.fordF1.semiBold,
            // Weight Semi-bold
            lineHeight: e.fpds.type.lineHeights[700],
            // Height 28px
            fontSize: e.fpds.type.fontSize[500]
            // Font-size 20px
          },
          type: "typography"
        },
        S: {
          value: {
            fontFamily: e.fpds.type.fontFamilies.FordF1,
            fontWeight: e.fpds.type.fontWeights.fordF1.semiBold,
            // Weight Semi-bold
            lineHeight: e.fpds.type.lineHeights[600],
            // Height 24px
            fontSize: e.fpds.type.fontSize[400]
            // Font-size 16px
          },
          type: "typography"
        },
        XS: {
          value: {
            fontFamily: e.fpds.type.fontFamilies.FordF1,
            fontWeight: e.fpds.type.fontWeights.fordF1.semiBold,
            // Weight Semi-bold
            lineHeight: e.fpds.type.lineHeights[600],
            // Height 24px
            fontSize: e.fpds.type.fontSize[350]
            // Font-size 14px
          },
          type: "typography"
        }
      },
      body: {
        semiBold: {
          L: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.semiBold,
              // Weight Semi-bold
              lineHeight: e.fpds.type.lineHeights[700],
              // Height 28px
              fontSize: e.fpds.type.fontSize[450]
              // Font-size 18px
            },
            type: "typography"
          },
          M: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.semiBold,
              // Weight Semi-bold
              lineHeight: e.fpds.type.lineHeights[600],
              // Height 24px
              fontSize: e.fpds.type.fontSize[400]
              // Font-size 16px
            },
            type: "typography"
          },
          S: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.semiBold,
              // Weight Semi-bold
              lineHeight: e.fpds.type.lineHeights[500],
              // Height 20px
              fontSize: e.fpds.type.fontSize[350]
              // Font-size 14px
            },
            type: "typography"
          },
          XS: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.semiBold,
              // Weight Semi-bold
              lineHeight: e.fpds.type.lineHeights[400],
              // Height 16px
              fontSize: e.fpds.type.fontSize[300]
              // Font-size 12px
            },
            type: "typography"
          }
        },
        medium: {
          L: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.medium,
              // Weight Medium
              lineHeight: e.fpds.type.lineHeights[700],
              // Height 28px
              fontSize: e.fpds.type.fontSize[450]
              // Font-size 18px
            },
            type: "typography"
          },
          M: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.medium,
              // Weight Medium
              lineHeight: e.fpds.type.lineHeights[600],
              // Height 24px
              fontSize: e.fpds.type.fontSize[400]
              // Font-size 16px
            },
            type: "typography"
          },
          S: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.medium,
              // Weight Medium
              lineHeight: e.fpds.type.lineHeights[500],
              // Height 20px
              fontSize: e.fpds.type.fontSize[350]
              // Font-size 14px
            },
            type: "typography"
          },
          XS: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.medium,
              // Weight Medium
              lineHeight: e.fpds.type.lineHeights[400],
              // Height 16px
              fontSize: e.fpds.type.fontSize[300]
              // Font-size 12px
            },
            type: "typography"
          }
        },
        regular: {
          L: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.regular,
              // Weight Regular
              lineHeight: e.fpds.type.lineHeights[700],
              // Height 28px
              fontSize: e.fpds.type.fontSize[450]
              // Font-size 18px
            },
            type: "typography"
          },
          M: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.regular,
              // Weight Regular
              lineHeight: e.fpds.type.lineHeights[600],
              // Height 24px
              fontSize: e.fpds.type.fontSize[400]
              // Font-size 16px
            },
            type: "typography"
          },
          S: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.regular,
              // Weight Regular
              lineHeight: e.fpds.type.lineHeights[500],
              // Height 20px
              fontSize: e.fpds.type.fontSize[350]
              // Font-size 14px
            },
            type: "typography"
          },
          XS: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.regular,
              // Weight Regular
              lineHeight: e.fpds.type.lineHeights[400],
              // Height 16px
              fontSize: e.fpds.type.fontSize[300]
              // Font-size 12px
            },
            type: "typography"
          }
        }
      },
      eyebrow: {
        semiBold: {
          S: {
            value: {
              fontFamily: e.fpds.type.fontFamilies.inter,
              fontWeight: e.fpds.type.fontWeights.inter.semiBold,
              // Weight Semi-bold
              lineHeight: e.fpds.type.lineHeights[400],
              // Height 28px
              fontSize: e.fpds.type.fontSize[300]
              // Font-size 18px
            },
            type: "typography"
          }
        }
      }
    },
    color: {
      text: {
        default: e.fpds.color.neutral[1200],
        // Use for main text (higest level in hierarchy)
        moderate: e.fpds.color.neutral[1e3],
        // Use for Body text that containes links.
        subtle: e.fpds.color.neutral[800],
        // Use for secondary text (Subtitles, Second level in hierarchy)
        subtlest: e.fpds.color.neutral[700],
        // Use for tertiary text (Disclaimers, Lowest in hierarchy)
        placeholder: e.fpds.color.neutral[600],
        // Use for placeholder text
        disabled: e.fpds.color.neutral[400],
        // Use for disabled text on fill-subtlest (Neutral00 / White)
        onDisabledSubtle: e.fpds.color.neutral["000"],
        // Use for disabled text on action.disabled fill
        onDisabledStrong: e.fpds.color.neutral[500],
        // Use for disabled text on fill.disabled
        primaryStrong: e.fpds.color.skyview[1100],
        // Use for the primary brand color text
        primaryStrongest: e.fpds.color.skyview[1200],
        // Use for primary brand text on fill.primary-subtle & fill.primary-subtlest
        secondaryStrong: e.fpds.color.fordBlue[1e3],
        // Use for text using the secondary brand color
        tertiaryStrong: e.fpds.color.grabber[1e3],
        // Use for text using the tertiary brand color
        dangerStrong: e.fpds.color.red[1e3],
        // Use for danger and error text
        dangerStrongest: e.fpds.color.red[1200],
        // Use for danger text on fill.danger-subtlest & fill.danger-subtle
        cautionStrong: e.fpds.color.amber[1e3],
        // Use for caution text
        cautionStrongest: e.fpds.color.amber[1200],
        // Use for caution text on fill.caution-subtlest & fill.caution-subtle
        successStrong: e.fpds.color.green[1e3],
        // Use for success text
        successStrongest: e.fpds.color.green[1200],
        // Use for success text on fill.success-subtlest & fill.success-subtle
        onColor: e.fpds.color.neutral["000"]
        // Use for text on colored fills
      },
      fill: {
        default: e.fpds.color.neutral["000"],
        // Use for default fills
        neutralSubtlest: e.fpds.color.neutral[100],
        // Use for subtlest neutral fills
        neutralSubtle: e.fpds.color.neutral[300],
        // Use for subtle neutral fills
        neutralModerate: e.fpds.color.neutral[600],
        // Use for moderate neutral fills
        neutralStrong: e.fpds.color.neutral[1e3],
        // Use for strong neutral fills
        disabled: e.fpds.color.neutral[200],
        // Use for disabled fills
        hover: e.fpds.color.neutral[200],
        // Use for hover fills
        secondarySubtlest: e.fpds.color.fordBlue[100],
        // Use for subtlest secondary brand color fills
        secondarySubtle: e.fpds.color.fordBlue[200],
        // Use for subtle secondary brand color fills
        secondaryStrong: e.fpds.color.fordBlue[1e3],
        // Use for secondary brand color fills
        tertiarySubtlest: e.fpds.color.grabber[100],
        // Use for subtlest tertiary brand color fills
        tertiarySubtle: e.fpds.color.grabber[200],
        // Use for subtle tertiary brand color fills
        tertiaryStrong: e.fpds.color.grabber[1e3],
        // Use for strong tertiary brand color fills
        primarySubtlest: e.fpds.color.skyview[100],
        // Use for subtlest primary brand color fills
        primarySubtle: e.fpds.color.skyview[200],
        // Use for subtle primary brand color fills
        primaryStrong: e.fpds.color.skyview[1e3],
        // Use for strong primary brand color fills
        primaryStrongest: e.fpds.color.skyview[1200],
        //Use for Strongest Primary brand color
        dangerSubtlest: e.fpds.color.red[100],
        // Use for subtlest danger color fills
        dangerSubtle: e.fpds.color.red[200],
        // Use for subtle danger color fills
        dangerStrong: e.fpds.color.red[1e3],
        // Use for strong danger color fills
        cautionSubtlest: e.fpds.color.amber[100],
        // Use for subtlest caution color fills
        cautionSubtle: e.fpds.color.amber[200],
        // Use for subtle caution color fills
        cautionStrong: e.fpds.color.amber[1e3],
        // Use for strong caution color fills
        successSubtlest: e.fpds.color.green[100],
        // Use for subtlest success color fills
        successSubtle: e.fpds.color.green[200],
        // Use for subtle success color fills
        successStrong: e.fpds.color.green[1e3],
        // Use for strong success color fills
        onColor: e.fpds.color.neutral["000"]
        // Use for fills on top of colored backgrounds
      },
      stroke: {
        default: e.fpds.color.neutral[400],
        // Use for default stroke (borders, dividers)
        disabled: e.fpds.color.neutral[400],
        // Use for disabled elements with a stroke
        focus: e.fpds.color.skyview[1e3],
        // Use for focus rings and focus strokes
        neutralSubtle: e.fpds.color.neutral[500],
        // Use for strokes on radio buttons, checkboxes
        neutralModerate: e.fpds.color.neutral[600],
        // Use for strokes that use a moderate neutral color
        neutralStrong: e.fpds.color.neutral[1e3],
        // Use for strong neutral strokes (Tooltips)
        primarySubtle: e.fpds.color.skyview[200],
        // Use for subtle primary brand color strokes
        primaryStrong: e.fpds.color.skyview[1e3],
        // Use for strong primary brand color strokes
        primaryStrongest: e.fpds.color.skyview[1200],
        // Use for strokes that use the strongest primary brand color
        danger: e.fpds.color.red[1e3],
        // Use for danger/ error strokes, borders and dividers
        dangerStrongest: e.fpds.color.red[1200],
        // Use for danger/ error strokes, borders and dividers on fill.danger-subtle and fill.danger-subtlest
        caution: e.fpds.color.amber[1e3],
        // Use for caution strokes, borders and dividers
        cautionStrongest: e.fpds.color.amber[1200],
        // Use for caution  strokes, borders and dividers on fill.caution-subtle and fill.caution-subtlest
        success: e.fpds.color.green[1e3],
        // Use for success strokes, borders and dividers
        successStrongest: e.fpds.color.green[1200],
        // Use for success strokes, borders and dividers on fill.success-subtle and fill.success-subtlest
        onColor: e.fpds.color.neutral["000"]
        // Use for strokes on coloured backgrounds
      },
      icon: {
        default: e.fpds.color.neutral[1e3],
        // Use for default icons
        neutralStrong: e.fpds.color.neutral[800],
        // Use for icons (Usually next to text.subtle)
        disabled: e.fpds.color.neutral[400],
        // Use for disabled icons
        onDisabled: e.fpds.color.neutral["000"],
        // Use for disabled icons on top of action disabled
        primary: e.fpds.color.skyview[1e3],
        // Use for primary brand color icons
        primaryStrongest: e.fpds.color.skyview[1200],
        // Use for primary brand color icons on fill.primary-subtlest & fill.primary-subtle
        secondary: e.fpds.color.fordBlue[1e3],
        // Use for secondary brand color icons
        secondaryStrongest: e.fpds.color.fordBlue[1200],
        // Use for secondary brand color icons on fill.secondary-subtle and fill.secondary-subtlest
        tertiaryStrong: e.fpds.color.grabber[1e3],
        // Use for teritary brand color icons
        danger: e.fpds.color.red[1e3],
        // Use for danger and error icons
        dangerStrongest: e.fpds.color.red[1200],
        // Use for danger icons on fill.danger-subtlest & fill.danger-subtle
        caution: e.fpds.color.amber[1e3],
        // Use for caution icons
        cautionStrongest: e.fpds.color.amber[1200],
        // Use for caution icons on fill.caution-subtlest & fill.caution-subtle
        success: e.fpds.color.green[1e3],
        // Use for success icons
        successStrongest: e.fpds.color.green[1200],
        // Use for success icons on fill.success-subtlest & fill.success-subtle
        onColor: e.fpds.color.neutral["000"]
        // Use for icons on coloured fills
      },
      action: {
        default: e.fpds.color.skyview[1e3],
        // Use for default actions (including buttons, radio buttons, checkboxes and switches)
        hover: e.fpds.color.skyview[1200],
        // Use for the hover state of default actions
        disabled: e.fpds.color.neutral[400],
        // Use for disabled state actions
        hoverSubtle: e.fpds.color.skyview[100],
        // Use for the container color when hovering over secondary & tertiary buttons
        danger: e.fpds.color.red[1e3],
        // Use for danger actions (including buttons, radio buttons, checkboxes and switches)
        dangerHover: e.fpds.color.red[1200],
        // Use for hover state of danger actions
        dangerHoverSubtle: e.fpds.color.red[100],
        // Use for the container color when hovering over secondary & tertiary danger buttons
        success: e.fpds.color.green[1e3],
        // Use for success actions
        successHover: e.fpds.color.green[1200],
        // Use for hover state of success actions
        successHoverSubtle: e.fpds.color.green[100],
        // Use for the container color when hovering over secondary & tertiary success buttons
        neutralModerate: e.fpds.color.neutral[600],
        // Use for off states on toggles
        neutralHoverSubtle: e.fpds.color.neutral[200],
        // Use for the container color when hovering over secondary & tertiary neutral buttons
        onColor: e.fpds.color.neutral["000"]
        // Use for actions on top of colored backgrounds or images
      },
      link: {
        default: e.fpds.color.skyview[1100],
        // Use for default links
        hover: e.fpds.color.skyview[1300],
        // Use for hovering over links
        neutral: e.fpds.color.neutral[500],
        // Use for disabled links and current page selector
        neutralStrong: e.fpds.color.neutral[1200],
        // Use for current page link in the breadcrumb
        active: e.fpds.color.grabber[700],
        // Use for active links
        visited: e.fpds.color.grabber[700],
        // Use for visited links
        onColor: e.fpds.color.neutral["000"],
        // Use for links on top of colored backgrounds
        onColorHover: e.fpds.color.neutral[400],
        // Use for hover state on links on top of colored backgrounds
        onStatus: {
          dangerHover: e.fpds.color.red[1400],
          // Use for hover state on links on top of colored backgrounds
          cautionHover: e.fpds.color.amber[1400],
          successHover: e.fpds.color.green[1400],
          neutralHover: e.fpds.color.neutral[700]
        }
      },
      table: {
        cell: {
          default: e.fpds.color.neutral["000"],
          selected: e.fpds.color.skyview[100],
          hover: e.fpds.color.neutral[100],
          accordion: e.fpds.color.neutral[200],
          noData: e.fpds.color.neutral[300]
        }
      },
      background: {
        default: e.fpds.color.neutral["000"],
        // Use for the default base background color only
        neutral: e.fpds.color.neutral[100]
        // Use for the neutral color background only
      },
      opacity: {
        surface: {
          inverted: {
            "00": e.fpds.color.opacity.light["00"],
            10: e.fpds.color.opacity.light[10],
            // Use for a dark surface opacity (00142e @ 10%)
            20: e.fpds.color.opacity.light[20],
            // Use for a dark surface opacity (00142e @ 20%)
            30: e.fpds.color.opacity.light[30],
            // Use for a dark surface opacity (00142e @ 30%)
            40: e.fpds.color.opacity.light[40],
            // Use for a dark surface opacity (00142e @ 40%)
            50: e.fpds.color.opacity.light[50],
            // Use for a dark surface opacity (00142e @ 50%)
            60: e.fpds.color.opacity.light[60],
            // Use for a dark surface opacity (00142e @ 60%)
            70: e.fpds.color.opacity.light[70],
            // Use for a dark surface opacity (00142e @ 70%)
            80: e.fpds.color.opacity.light[80],
            // Use for a dark surface opacity (00142e @ 80%)
            90: e.fpds.color.opacity.light[90],
            // Use for a dark surface opacity (00142e @ 90%)
            100: e.fpds.color.opacity.light[100]
            // Use for a darkest surface opacity (00142e @ 100%)
          },
          default: {
            "00": e.fpds.color.opacity.dark["00"],
            10: e.fpds.color.opacity.dark[10],
            // Use for a light surface opacity (ffffff @ 10%)
            20: e.fpds.color.opacity.dark[20],
            // Use for a light surface opacity (ffffff @ 20%)
            30: e.fpds.color.opacity.dark[30],
            // Use for a light surface opacity (ffffff @ 30%)
            40: e.fpds.color.opacity.dark[40],
            // Use for a light surface opacity (ffffff @ 40%)
            50: e.fpds.color.opacity.dark[50],
            // Use for a light surface opacity (ffffff @ 50%)
            60: e.fpds.color.opacity.dark[60],
            // Use for a light surface opacity (ffffff @ 60%)
            70: e.fpds.color.opacity.dark[70],
            // Use for a light surface opacity (ffffff @ 70%)
            80: e.fpds.color.opacity.dark[80],
            // Use for a light surface opacity (ffffff @ 80%)
            90: e.fpds.color.opacity.dark[90],
            // Use for a light surface opacity (ffffff @ 90%)
            100: e.fpds.color.opacity.dark[100]
            // Use for a lightest surface opacity (ffffff @ 100%)
          }
        },
        scrim: {
          white: {
            10: e.fpds.color.opacity.dark[10],
            // Use for a white scrim opacity (ffffff @ 10%)
            20: e.fpds.color.opacity.dark[20],
            // Use for a white scrim opacity (ffffff @ 20%)
            30: e.fpds.color.opacity.dark[30],
            // Use for a white scrim opacity (ffffff @ 30%)
            40: e.fpds.color.opacity.dark[40],
            // Use for a white scrim opacity (ffffff @ 40%)
            50: e.fpds.color.opacity.dark[50],
            // Use for a white scrim opacity (ffffff @ 50%)
            60: e.fpds.color.opacity.dark[60],
            // Use for a white scrim opacity (ffffff @ 60%)
            70: e.fpds.color.opacity.dark[70],
            // Use for a white scrim opacity (ffffff @ 70%)
            80: e.fpds.color.opacity.dark[80],
            // Use for a white scrim opacity (ffffff @ 80%)
            90: e.fpds.color.opacity.dark[90],
            // Use for a white scrim opacity (ffffff @ 90%)
            100: e.fpds.color.opacity.dark[100]
            // Use for a white scrim opacity (ffffff @ 100%)
          },
          black: {
            10: e.fpds.color.opacity.light[10],
            // Use for a black scrim opacity (00142e @ 10%)
            20: e.fpds.color.opacity.light[20],
            // Use for a black scrim opacity (00142e @ 20%)
            30: e.fpds.color.opacity.light[30],
            // Use for a black scrim opacity (00142e @ 30%)
            40: e.fpds.color.opacity.light[40],
            // Use for a black scrim opacity (00142e @ 40%)
            50: e.fpds.color.opacity.light[50],
            // Use for a black scrim opacity (00142e @ 50%)
            60: e.fpds.color.opacity.light[60],
            // Use for a black scrim opacity (00142e @ 60%)
            70: e.fpds.color.opacity.light[70],
            // Use for a black scrim opacity (00142e @ 70%)
            80: e.fpds.color.opacity.light[80],
            // Use for a black scrim opacity (00142e @ 80%)
            90: e.fpds.color.opacity.light[90],
            // Use for a black scrim opacity (00142e @ 90%)
            100: e.fpds.color.opacity.light[100]
            // Use for a black scrim opacity (00142e @ 100%)
          }
        }
      },
      chart: {
        default: {
          subtlest: e.fpds.color.skyview[200],
          subtle: e.fpds.color.skyview[500],
          moderate: e.fpds.color.skyview[800],
          strong: e.fpds.color.skyview[1100],
          strongest: e.fpds.color.skyview[1400],
          subtlestOpacity: e.fpds.color.opacity.skyview[200],
          subtleOpacity: e.fpds.color.opacity.skyview[500],
          moderateOpacity: e.fpds.color.opacity.skyview[800],
          strongOpacity: e.fpds.color.opacity.skyview[1100],
          strongestOpacity: e.fpds.color.opacity.skyview[1400]
        },
        fordBlue: {
          subtlest: e.fpds.color.fordBlue[200],
          subtle: e.fpds.color.fordBlue[500],
          moderate: e.fpds.color.fordBlue[800],
          strong: e.fpds.color.fordBlue[1100],
          strongest: e.fpds.color.fordBlue[1400],
          subtlestOpacity: e.fpds.color.opacity.fordBlue[200],
          subtleOpacity: e.fpds.color.opacity.fordBlue[500],
          moderateOpacity: e.fpds.color.opacity.fordBlue[800],
          strongOpacity: e.fpds.color.opacity.fordBlue[1100],
          strongestOpacity: e.fpds.color.opacity.fordBlue[1400]
        },
        fordGrabber: {
          subtlest: e.fpds.color.grabber[200],
          subtle: e.fpds.color.grabber[500],
          moderate: e.fpds.color.grabber[800],
          strong: e.fpds.color.grabber[1e3],
          strongest: e.fpds.color.grabber[1400],
          subtlestOpacity: e.fpds.color.opacity.fordGrabber[200],
          subtleOpacity: e.fpds.color.opacity.fordGrabber[500],
          moderateOpacity: e.fpds.color.opacity.fordGrabber[800],
          strongOpacity: e.fpds.color.opacity.fordGrabber[1100],
          strongestOpacity: e.fpds.color.opacity.fordGrabber[1400]
        },
        neutral: {
          subtlest: e.fpds.color.neutral[400],
          subtle: e.fpds.color.neutral[600],
          moderate: e.fpds.color.neutral[800],
          strong: e.fpds.color.neutral[1e3],
          strongest: e.fpds.color.neutral[1400],
          subtlestOpacity: e.fpds.color.opacity.neutral[200],
          subtleOpacity: e.fpds.color.opacity.neutral[500],
          moderateOpacity: e.fpds.color.opacity.neutral[800],
          strongOpacity: e.fpds.color.opacity.neutral[1100],
          strongestOpacity: e.fpds.color.opacity.neutral[1400]
        },
        danger: {
          subtlest: e.fpds.color.red[200],
          subtle: e.fpds.color.red[500],
          moderate: e.fpds.color.red[800],
          strong: e.fpds.color.red[1100],
          strongest: e.fpds.color.red[1400],
          subtlestOpacity: e.fpds.color.opacity.red[200],
          subtleOpacity: e.fpds.color.opacity.red[500],
          moderateOpacity: e.fpds.color.opacity.red[800],
          strongOpacity: e.fpds.color.opacity.red[1100],
          strongestOpacity: e.fpds.color.opacity.red[1400]
        },
        caution: {
          subtlest: e.fpds.color.orange[200],
          subtle: e.fpds.color.orange[500],
          moderate: e.fpds.color.orange[800],
          strong: e.fpds.color.orange[1100],
          strongest: e.fpds.color.orange[1400],
          subtlestOpacity: e.fpds.color.opacity.orange[200],
          subtleOpacity: e.fpds.color.opacity.orange[500],
          moderateOpacity: e.fpds.color.opacity.orange[800],
          strongOpacity: e.fpds.color.opacity.orange[1100],
          strongestOpacity: e.fpds.color.opacity.orange[1400]
        },
        success: {
          subtlest: e.fpds.color.green[200],
          subtle: e.fpds.color.green[500],
          moderate: e.fpds.color.green[800],
          strong: e.fpds.color.green[1100],
          strongest: e.fpds.color.green[1400],
          subtlestOpacity: e.fpds.color.opacity.green[200],
          subtleOpacity: e.fpds.color.opacity.green[500],
          moderateOpacity: e.fpds.color.opacity.green[800],
          strongOpacity: e.fpds.color.opacity.green[1100],
          strongestOpacity: e.fpds.color.opacity.green[1400]
        },
        teal: {
          subtlest: e.fpds.color.teal[200],
          subtle: e.fpds.color.teal[500],
          moderate: e.fpds.color.teal[800],
          strong: e.fpds.color.teal[1100],
          strongest: e.fpds.color.teal[1400],
          subtlestOpacity: e.fpds.color.opacity.teal[200],
          subtleOpacity: e.fpds.color.opacity.teal[500],
          moderateOpacity: e.fpds.color.opacity.teal[800],
          strongOpacity: e.fpds.color.opacity.teal[1100],
          strongestOpacity: e.fpds.color.opacity.teal[1400]
        },
        magenta: {
          subtlest: e.fpds.color.magenta[200],
          subtle: e.fpds.color.magenta[500],
          moderate: e.fpds.color.magenta[800],
          strong: e.fpds.color.magenta[1100],
          strongest: e.fpds.color.magenta[1400],
          subtlestOpacity: e.fpds.color.opacity.magenta[200],
          subtleOpacity: e.fpds.color.opacity.magenta[500],
          moderateOpacity: e.fpds.color.opacity.magenta[800],
          strongOpacity: e.fpds.color.opacity.magenta[1100],
          strongestOpacity: e.fpds.color.opacity.magenta[1400]
        },
        purple: {
          subtlest: e.fpds.color.purple[200],
          subtle: e.fpds.color.purple[500],
          moderate: e.fpds.color.purple[800],
          strong: e.fpds.color.purple[1100],
          strongest: e.fpds.color.purple[1400],
          subtlestOpacity: e.fpds.color.opacity.purple[200],
          subtleOpacity: e.fpds.color.opacity.purple[500],
          moderateOpacity: e.fpds.color.opacity.purple[800],
          strongOpacity: e.fpds.color.opacity.purple[1100],
          strongestOpacity: e.fpds.color.opacity.purple[1400]
        },
        yellow: {
          subtlest: e.fpds.color.yellow[200],
          subtle: e.fpds.color.yellow[500],
          moderate: e.fpds.color.yellow[800],
          strong: e.fpds.color.yellow[1e3],
          strongest: e.fpds.color.yellow[1400],
          subtlestOpacity: e.fpds.color.opacity.yellow[200],
          subtleOpacity: e.fpds.color.opacity.yellow[500],
          moderateOpacity: e.fpds.color.opacity.yellow[800],
          strongOpacity: e.fpds.color.opacity.yellow[1100],
          strongestOpacity: e.fpds.color.opacity.yellow[1400]
        }
      }
    },
    space: {
      "0x": e.fpds.number["000"],
      // 0px spacing
      ".25x": e.fpds.number["025"],
      // 1px spacing
      ".5x": e.fpds.number["050"],
      // 2px spacing
      "1x": e.fpds.number[100],
      // 4px spacing
      "2x": e.fpds.number[200],
      // 8px spacing
      "3x": e.fpds.number[300],
      // 12px spacing
      "4x": e.fpds.number[400],
      // 16px spacing
      "5x": e.fpds.number[500],
      // 20px spacing
      "6x": e.fpds.number[600],
      // 24px spacing
      "7x": e.fpds.number[700],
      // 28px spacing
      "8x": e.fpds.number[800],
      // 32px spacing
      "10x": e.fpds.number[1e3],
      // 40px spacing
      "12x": e.fpds.number[1200],
      // 48px spacing
      "14x": "56px",
      // added custom in UCL
      "15x": e.fpds.number[1500],
      // 60px spacing
      "16x": e.fpds.number[1600],
      // 64px spacing
      "18x": e.fpds.number[1800],
      // 72px spacing
      "20x": e.fpds.number[2e3],
      // 80px spacing
      "22x": e.fpds.number[2200],
      // 88px spacing
      "24x": e.fpds.number[2400],
      // 96px spacing
      "26x": e.fpds.number[2600],
      // 104px spacing
      "28x": "112px"
      // added custom in UCL
    },
    size: {
      "0x": e.fpds.number["000"],
      // 0px sizing
      "1x": e.fpds.number[100],
      // 4px sizing
      "2x": e.fpds.number[200],
      // 8px sizing
      "3x": e.fpds.number[300],
      // 12px sizing
      "4x": e.fpds.number[400],
      // 16px sizing
      "5x": e.fpds.number[500],
      // 20px sizing
      "6x": e.fpds.number[600],
      // 24px sizing
      "7x": e.fpds.number[700],
      // 28px sizing
      "8x": e.fpds.number[800],
      // 32px sizing
      "10x": e.fpds.number[1e3],
      // 40px sizing
      "12x": e.fpds.number[1200],
      // 48px sizing
      "15x": e.fpds.number[1500]
      // 60px sizing
    },
    radius: {
      "0x": e.fpds.number["000"],
      // 0px radius
      "1x": e.fpds.number[100],
      // 4px radius
      "2x": e.fpds.number[200],
      // 8px radius
      "3x": e.fpds.number[300],
      // 12px radius
      "4x": e.fpds.number[400],
      // 16px radius
      "5x": e.fpds.number[500],
      // 20px radius
      "6x": e.fpds.number[600],
      // 24px radius
      "7x": e.fpds.number[700],
      // 28px radius
      "8x": e.fpds.number[800],
      // 32px radius
      "10x": e.fpds.number[1e3],
      // 40px radius
      max: e.fpds.number.max
      // 40px radius
    },
    borderWidth: {
      "1x": e.fpds.number["025"],
      // 1px width
      "2x": e.fpds.number["050"],
      // 2px width
      "4x": e.fpds.number[100],
      // 4px width
      "8x": e.fpds.number[200]
      // 8px width
    },
    $themes: [],
    $metadata: {
      tokenSetOrder: ["fpds-light"]
    }
  }
}, D = {
  headline: {
    XXL: a["fpds-light"].type.headline.XXL.value,
    XL: a["fpds-light"].type.headline.XL.value,
    L: a["fpds-light"].type.headline.L.value,
    M: a["fpds-light"].type.headline.M.value,
    S: a["fpds-light"].type.headline.S.value,
    XS: a["fpds-light"].type.headline.XS.value
  },
  body: {
    semiBold: {
      L: a["fpds-light"].type.body.semiBold.L.value,
      M: a["fpds-light"].type.body.semiBold.M.value,
      S: a["fpds-light"].type.body.semiBold.S.value,
      XS: a["fpds-light"].type.body.semiBold.XS.value
    },
    medium: {
      L: a["fpds-light"].type.body.medium.L.value,
      M: a["fpds-light"].type.body.medium.M.value,
      S: a["fpds-light"].type.body.medium.S.value,
      XS: a["fpds-light"].type.body.medium.XS.value
    },
    regular: {
      L: a["fpds-light"].type.body.regular.L.value,
      M: a["fpds-light"].type.body.regular.M.value,
      S: a["fpds-light"].type.body.regular.S.value,
      XS: a["fpds-light"].type.body.regular.XS.value
    }
  },
  eyebrow: {
    semiBold: {
      S: a["fpds-light"].type.eyebrow.semiBold.S.value
    }
  }
}, r = {
  primitive: {
    typography: e.fpds.type,
    color: e.fpds.color,
    lineHeight: e.fpds.type.lineHeights,
    fontFamilies: e.fpds.type.fontFamilies,
    fontWeight: {
      fordF1: e.fpds.type.fontWeights.fordF1,
      inter: e.fpds.type.fontWeights.inter
    },
    fontSize: e.fpds.type.fontSize
  },
  semantic: {
    color: a["fpds-light"].color,
    radius: a["fpds-light"].radius,
    space: a["fpds-light"].space,
    size: a["fpds-light"].size,
    borderWidth: a["fpds-light"].borderWidth,
    typography: D
  }
}, c = (i) => i.replace(/([A-Z])/g, "-$1").toLowerCase();
function M(i, n) {
  return typeof i == "string" ? n ? `var(--${c(i)}, var(--${c(n)}))` : `var(--${c(i.replace(/_/g, ""))}, var(--_${c(i.replace(/_/g, ""))}))` : Object.entries(i).reduce((f, [y, g]) => (f[`--${c(y)}`] = `var(--${c(g)})`, f), {});
}
const u = (i) => i.replace(/([A-Z])/g, "-$1").toLowerCase();
function l(i, n) {
  return typeof i == "string" ? n === void 0 ? `var(--${u(i)})` : `var(--${u(i)}, ${n})` : Object.entries(i).reduce((f, [y, g]) => (f[`--${u(y)}`] = g, f), {});
}
l.fallback = M;
l.toHyphenated = u;
const t = (i) => {
  const { color: n, ...m } = i;
  return m;
}, v = {
  ...o.semanticMode1.caption.regular.value,
  color: l("textColor", o.primitive.color.neutral[700].value),
  minWidth: "max-content",
  textAlign: "left",
  "&.regular, .regular": t(o.semanticMode1.caption.regular.value),
  "&.medium, .medium": t(o.semanticMode1.caption.medium.value),
  "&.semi-bold, .semi-bold, b": t(o.semanticMode1.caption.semibold.value)
}, x = {
  margin: "0px",
  ...o.semanticMode1.body1.regular.value,
  color: l("textColor", o.primitive.color.neutral[900].value),
  "&.medium-text, .medium-text": {
    ...o.semanticMode1.body1.regular.value,
    color: "currentColor",
    "&.light, .light": t(o.semanticMode1.body1.light.value),
    "&.regular, .regular": t(o.semanticMode1.body1.regular.value),
    "&.medium, .medium": t(o.semanticMode1.body1.medium.value),
    "&.bold, .bold, b": t(o.semanticMode1.body1.bold.value),
    "&.semi-bold, .semi-bold, b": t(o.semanticMode1.body1.semibold.value)
  },
  "&.small-text, .small-text": {
    ...o.semanticMode1.body2.regular.value,
    color: "currentColor",
    "&.light, .light": t(o.semanticMode1.body2.light.value),
    "&.regular, .regular": t(o.semanticMode1.body2.regular.value),
    "&.medium, .medium": t(o.semanticMode1.body2.medium.value),
    "&.bold, .bold, b": t(o.semanticMode1.body2.bold.value),
    "&.semi-bold, .semi-bold, b": t(o.semanticMode1.body2.semibold.value)
  },
  "&.caption, &.extra-small-text, .caption, .extra-small-text": v,
  sup: {
    fontSize: "75%",
    color: "currentColor"
  }
}, b = {
  marginLeft: o.semanticMode1.space.sm.value,
  paddingLeft: o.semanticMode1.space.lg.value,
  li: {
    "ol, ul": {
      paddingLeft: 0,
      marginLeft: o.semanticMode1.space["2xl"].value
    }
  }
}, B = x, k = {
  ...l({ _anchorColor: o.semanticMode1.color.text.onLight.interactive.value }),
  color: l.fallback("_anchorColor"),
  textDecorationColor: l.fallback("_anchorTextDecorationColor"),
  outlineColor: l.fallback("_anchorOutlineColor"),
  font: "inherit",
  textDecoration: "none",
  textUnderlineOffset: o.semanticMode1.space.xs.value,
  cursor: "pointer",
  "&:link, &:visited": {
    textDecoration: "none"
  },
  "&:hover": {
    ...l({
      _anchorColor: o.semanticMode1.color.text.onLight.interactiveHover.value,
      _anchorTextDecorationColor: o.semanticMode1.color.text.onLight.interactiveHover.value
    }),
    textDecoration: "underline",
    textUnderlineOffset: o.primitive.space["1x"].value
  },
  "&:active": {
    ...l({
      _anchorColor: o.primitive.color.fordBlue[700].value,
      _anchorTextDecorationColor: o.primitive.color.fordBlue[700].value
    }),
    textDecoration: "underline",
    textUnderlineOffset: o.primitive.space["1x"].value
  },
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    ...l({ _anchorOutlineColor: o.primitive.color.neutral[1200].value }),
    textDecoration: "underline",
    outlineOffset: o.primitive.space["1x"].value,
    outlineWidth: o.primitive.border["2x"].value,
    outlineStyle: "solid",
    borderRadius: o.primitive.radius["1x"].value
  }
}, O = {
  margin: "0px",
  fontSize: "75%",
  color: "currentColor",
  a: {
    textUnderlineOffset: "2px"
  }
}, w = {
  margin: "0px",
  ...o.semanticMode1.headline1.regular.large.value,
  color: l("textColor", o.primitive.color.neutral[900].value),
  "&.regular, .regular": t(o.semanticMode1.headline1.regular.large.value),
  "&.semi-bold, .semi-bold": t(o.semanticMode1.headline1.semibold.large.value),
  [`@media ${p.mobile}`]: {
    ...t(o.semanticMode1.headline1.regular.small.value),
    "&.regular, .regular": t(o.semanticMode1.headline1.regular.small.value),
    "&.semi-bold, .semi-bold": t(o.semanticMode1.headline1.semibold.small.value)
  },
  "&.display-1, .display-1": {
    ...t(o.semanticMode1.display1.regular.large.value),
    "&.regular, .regular": t(o.semanticMode1.display1.regular.large.value),
    "&.semi-bold, .semi-bold": t(o.semanticMode1.display1.semibold.large.value),
    [`@media ${p.mobile}`]: {
      ...t(o.semanticMode1.display1.regular.small.value),
      "&.regular, .regular": t(o.semanticMode1.display1.regular.small.value),
      "&.semi-bold, .semi-bold": t(o.semanticMode1.display1.semibold.small.value)
    }
  },
  sup: {
    fontSize: "50%",
    color: "currentColor"
  }
}, z = {
  margin: "0px",
  ...o.semanticMode1.headline2.regular.large.value,
  color: l("textColor", o.primitive.color.neutral[900].value),
  "&.regular, .regular": t(o.semanticMode1.headline2.regular.large.value),
  "&.semi-bold, .semi-bold": t(o.semanticMode1.headline2.semibold.large.value),
  [`@media ${p.mobile}`]: {
    ...t(o.semanticMode1.headline2.regular.small.value),
    "&.regular, .regular": t(o.semanticMode1.headline2.regular.small.value),
    "&.semi-bold, .semi-bold": t(o.semanticMode1.headline2.semibold.small.value)
  },
  "&.display-2, .display-2": {
    ...t(o.semanticMode1.display2.regular.large.value),
    "&.regular, .regular": t(o.semanticMode1.display2.regular.large.value),
    "&.semi-bold, .semi-bold": t(o.semanticMode1.display2.semibold.large.value),
    [`@media ${p.mobile}`]: {
      ...t(o.semanticMode1.display2.regular.small.value),
      "&.regular, .regular": t(o.semanticMode1.display2.regular.small.value),
      "&.semi-bold, .semi-bold": t(o.semanticMode1.display2.semibold.small.value)
    }
  },
  sup: {
    fontSize: "50%",
    color: "currentColor"
  }
}, H = {
  margin: "0px",
  ...o.semanticMode1.headline3.regular.large.value,
  color: l("textColor", o.primitive.color.neutral[900].value),
  "&.regular, .regular": t(o.semanticMode1.headline3.regular.large.value),
  "&.semi-bold, .semi-bold": t(o.semanticMode1.headline3.semibold.large.value),
  [`@media ${p.mobile}`]: {
    ...t(o.semanticMode1.headline3.regular.small.value),
    "&.regular, .regular": t(o.semanticMode1.headline3.regular.small.value),
    "&.semi-bold, .semi-bold": t(o.semanticMode1.headline3.semibold.small.value)
  },
  "&.display-3, .display-3": {
    ...t(o.semanticMode1.display3.regular.large.value),
    "&.regular, .regular": t(o.semanticMode1.display3.regular.large.value),
    "&.semi-bold, .semi-bold": t(o.semanticMode1.display3.semibold.large.value),
    [`@media ${p.mobile}`]: {
      ...t(o.semanticMode1.display3.regular.small.value),
      "&.regular, .regular": t(o.semanticMode1.display3.regular.small.value),
      "&.semi-bold, .semi-bold": t(o.semanticMode1.display3.semibold.small.value)
    }
  },
  sup: {
    fontSize: "50%",
    color: "currentColor"
  }
}, $ = {
  margin: "0px",
  ...o.semanticMode1.headline4.regular.large.value,
  color: l("textColor", o.primitive.color.neutral[900].value),
  "&.regular, .regular": t(o.semanticMode1.headline4.regular.large.value),
  "&.semi-bold, .semi-bold": t(o.semanticMode1.headline4.semibold.large.value),
  [`@media ${p.mobile}`]: {
    ...t(o.semanticMode1.headline4.regular.small.value),
    "&.regular, .regular": t(o.semanticMode1.headline4.regular.small.value),
    "&.semi-bold, .semi-bold": t(o.semanticMode1.headline4.semibold.small.value)
  },
  "&.title, .title": {
    ...t(o.semanticMode1.title.medium.value),
    "&.medium, .medium": t(o.semanticMode1.title.medium.value),
    "&.bold, .bold": t(o.semanticMode1.title.bold.value)
  },
  sup: {
    fontSize: "50%",
    color: "currentColor"
  }
}, W = {
  margin: "0px",
  ...o.semanticMode1.headline5.regular.large.value,
  color: l("textColor", o.primitive.color.neutral[900].value),
  "&.regular, .regular": t(o.semanticMode1.headline5.regular.large.value),
  "&.semi-bold, .semi-bold": t(o.semanticMode1.headline5.semibold.large.value),
  [`@media ${p.mobile}`]: {
    ...t(o.semanticMode1.headline5.regular.small.value),
    "&.regular, .regular": t(o.semanticMode1.headline5.regular.small.value),
    "&.semi-bold, .semi-bold": t(o.semanticMode1.headline5.semibold.small.value)
  },
  "&.sub-title, .sub-title": {
    ...t(o.semanticMode1.subtitle.regular.value),
    "&.regular, .regular": t(o.semanticMode1.subtitle.regular.value)
  },
  sup: {
    fontSize: "50%",
    color: "currentColor"
  }
}, L = {
  margin: "0px",
  ...o.semanticMode1.headline6.medium.large.value,
  color: l("textColor", o.primitive.color.neutral[900].value),
  "&.medium, .medium": t(o.semanticMode1.headline6.medium.large.value),
  [`@media ${p.mobile}`]: {
    ...t(o.semanticMode1.headline6.medium.small.value),
    "&.medium, .medium": t(o.semanticMode1.headline6.medium.small.value)
  },
  sup: {
    fontSize: "50%",
    color: "currentColor"
  }
}, s = {
  sup: O,
  a: k,
  caption: v,
  p: x,
  ul: b,
  ol: b,
  li: B,
  h1: w,
  h2: z,
  h3: H,
  h4: $,
  h5: W,
  h6: L
}, A = {
  ...s.caption,
  color: l("textColor", o.primitive.color.neutral[100].value)
}, E = {
  ...s.p,
  color: l("textColor", o.primitive.color.neutral[100].value)
}, X = {
  ...s.a,
  ...l({ _anchorColor: o.semanticMode1.color.text.onDark.interactive.value }),
  color: l.fallback("_anchorColor"),
  textDecorationColor: l.fallback("_anchorTextDecorationColor"),
  outlineColor: l.fallback("_anchorOutlineColor"),
  "&:link, &:visited": {
    textDecoration: "none"
  },
  "&:hover": {
    ...l({
      _anchorColor: o.semanticMode1.color.text.onDark.interactiveHover.value,
      _anchorTextDecorationColor: o.semanticMode1.color.text.onDark.interactiveHover.value
    }),
    textDecoration: "underline",
    textUnderlineOffset: o.primitive.space["1x"].value
  },
  "&:active": {
    ...l({
      _anchorColor: o.semanticMode1.color.text.onDark.interactiveHover.value,
      _anchorTextDecorationColor: o.semanticMode1.color.text.onDark.interactiveHover.value
    }),
    textDecoration: "underline",
    textUnderlineOffset: o.primitive.space["1x"].value
  },
  "&:focus-visible": {
    ...l({ _anchorOutlineColor: o.primitive.color.neutral["000"].value }),
    textDecoration: "underline",
    outlineOffset: o.primitive.space["1x"].value,
    outlineWidth: o.primitive.border["2x"].value,
    outlineStyle: "solid",
    borderRadius: o.primitive.radius["1x"].value
  }
}, _ = {
  ...s.h1,
  color: l("textColor", o.primitive.color.neutral[100].value)
}, U = {
  ...s.h2,
  color: l("textColor", o.primitive.color.neutral[100].value)
}, T = {
  ...s.h3,
  color: l("textColor", o.primitive.color.neutral[100].value)
}, R = {
  ...s.h4,
  color: l("textColor", o.primitive.color.neutral[100].value)
}, G = {
  ...s.h5,
  color: l("textColor", o.primitive.color.neutral[100].value)
}, I = {
  ...s.h6,
  color: l("textColor", o.primitive.color.neutral[100].value)
}, te = {
  ...s,
  a: X,
  caption: A,
  p: E,
  h1: _,
  h2: U,
  h3: T,
  h4: R,
  h5: G,
  h6: I
}, F = {
  ...r.semantic.typography.body.regular.XS,
  "&.regular, .regular": r.semantic.typography.body.regular.XS,
  "&.medium, .medium": r.semantic.typography.body.medium.XS,
  "&.semi-bold, .semi-bold, b": r.semantic.typography.body.semiBold.XS,
  "&.bold, .bold, b": r.semantic.typography.body.semiBold.XS,
  color: l("textColor", "currentColor"),
  minWidth: "max-content",
  textAlign: "left"
}, S = {
  margin: "0px",
  letterSpacing: "0px",
  color: l("textColor", r.semantic.color.text.default),
  ...r.semantic.typography.body.regular.M,
  "&.large-text, .large-text": {
    ...r.semantic.typography.body.regular.L,
    "&.regular, .regular": r.semantic.typography.body.regular.L,
    "&.medium, .medium": r.semantic.typography.body.medium.L,
    "&.semi-bold, .semi-bold, b": r.semantic.typography.body.semiBold.L,
    "&.bold, .bold, b": r.semantic.typography.body.semiBold.L
  },
  "&.medium-text, .medium-text": {
    ...r.semantic.typography.body.regular.M,
    "&.regular, .regular": r.semantic.typography.body.regular.M,
    "&.medium, .medium": r.semantic.typography.body.medium.M,
    "&.semi-bold, .semi-bold, b": r.semantic.typography.body.semiBold.M,
    "&.bold, .bold, b": r.semantic.typography.body.semiBold.M
  },
  "&.small-text, .small-text": {
    ...r.semantic.typography.body.regular.S,
    "&.regular, .regular": r.semantic.typography.body.regular.S,
    "&.medium, .medium": r.semantic.typography.body.medium.S,
    "&.semi-bold, .semi-bold, b": r.semantic.typography.body.semiBold.S,
    "&.bold, .bold, b": r.semantic.typography.body.semiBold.S
  },
  "&.caption, &.extra-small-text, .caption, .extra-small-text": F,
  sup: {
    fontSize: "75%"
  }
}, C = {
  marginLeft: r.semantic.space["2x"],
  paddingLeft: r.semantic.space["4x"]
}, P = {
  ...C,
  li: {
    ol: {
      paddingLeft: 0,
      marginLeft: r.semantic.space["8x"]
    }
  }
}, j = {
  ...C,
  li: {
    "&::marker": {
      color: r.semantic.color.icon.primary
    },
    "ul, ol": {
      paddingLeft: 0,
      marginLeft: r.semantic.space["8x"]
    }
  }
}, Q = S, V = {
  ...l({ _anchorColor: r.semantic.color.link.default }),
  color: l.fallback("_anchorColor"),
  textDecorationColor: l.fallback("_anchorTextDecorationColor"),
  outlineColor: l.fallback("_anchorOutlineColor"),
  font: "inherit",
  cursor: "pointer",
  textUnderlineOffset: r.semantic.space["1x"],
  "&:link, &:visited": {
    textDecoration: "none"
  },
  "&:hover": {
    ...l({
      _anchorColor: r.semantic.color.link.hover,
      _anchorTextDecorationColor: r.semantic.color.link.hover
    }),
    textDecoration: "underline"
  },
  "&:active": {
    ...l({
      _anchorColor: r.semantic.color.link.active,
      _anchorTextDecorationColor: r.semantic.color.link.active
    }),
    textDecoration: "underline"
  },
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    ...l({ _anchorOutlineColor: r.semantic.color.stroke.focus }),
    textDecoration: "underline",
    outlineWidth: r.semantic.space[".5x"],
    outlineOffset: r.semantic.space["1x"],
    outlineStyle: "solid",
    borderRadius: r.semantic.radius["1x"]
  }
}, Z = {
  margin: "0px",
  lineHeight: 0,
  fontSize: "75%",
  color: "currentColor",
  a: {
    textUnderlineOffset: e.fpds.number["050"]
  }
}, K = {
  margin: "0px",
  ...r.semantic.typography.headline.XXL,
  color: l("textColor", r.semantic.color.text.default),
  sup: {
    fontSize: "50%"
  }
}, q = {
  margin: "0px",
  ...r.semantic.typography.headline.XL,
  color: l("textColor", r.semantic.color.text.default),
  sup: {
    fontSize: "50%"
  }
}, J = {
  margin: "0px",
  ...r.semantic.typography.headline.L,
  color: l("textColor", r.semantic.color.text.default),
  sup: {
    fontSize: "50%"
  }
}, N = {
  margin: "0px",
  ...r.semantic.typography.headline.M,
  color: l("textColor", r.semantic.color.text.default),
  sup: {
    fontSize: "50%"
  }
}, Y = {
  margin: "0px",
  ...r.semantic.typography.headline.S,
  color: l("textColor", r.semantic.color.text.default),
  sup: {
    fontSize: "50%"
  }
}, ee = {
  margin: "0px",
  ...r.semantic.typography.headline.XS,
  color: l("textColor", r.semantic.color.text.default),
  sup: {
    fontSize: "50%"
  }
}, h = {
  sup: Z,
  a: V,
  caption: F,
  p: S,
  ul: j,
  ol: P,
  li: Q,
  h1: K,
  h2: q,
  h3: J,
  h4: N,
  h5: Y,
  h6: ee
}, re = {
  sup: s.sup,
  "a:not(.Button,.Link,.PageLink,.IconButton)": s.a,
  "h1, h2, h3, h4, h5, h6": {
    sup: {
      fontSize: "50%"
    }
  }
}, le = {
  sup: h.sup,
  "a:not(.Button,.Link,.PageLink,.IconButton)": h.a,
  "h1, h2, h3, h4, h5, h6": {
    sup: {
      fontSize: "50%"
    }
  }
};
export {
  d as B,
  h as F,
  p as Q,
  te as a,
  s as b,
  l as c,
  le as d,
  re as e,
  r as f,
  e as p
};
